import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginCurrencyHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import NoDataContainer from "../../../../generic/noDataContainer";

export interface IMarginCurrencyTableDskProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginCurrencyTableDsk: React.FC<IMarginCurrencyTableDskProps> = props => {
	return (
		<div className="mrgn_curr_tbl table">
			<ul className="hdr_row">
				<li className="tr">
					<div className="td trdSym">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="trdSym"
								onSort={props.sortProps.onSort}
								colName={marginCurrencyHeading.trdSym}
							/>
						</span>
					</div>
					<div className="td LotSize">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="LotSize"
								onSort={props.sortProps.onSort}
								colName={marginCurrencyHeading.lotSize}
							/>
						</span>
					</div>
					<div className="td SPANMarginAmt right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="SPANMarginAmt"
								onSort={props.sortProps.onSort}
								colName={marginCurrencyHeading.spanMarginAmt}
							/>
						</span>
					</div>
					<div className="td ExpMarginamt right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="ExpMarginamt"
								onSort={props.sortProps.onSort}
								colName={marginCurrencyHeading.expMarginamt}
							/>
						</span>
					</div>
					<div className="td TotalMarginamt right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="TotalMarginamt"
								onSort={props.sortProps.onSort}
								colName={marginCurrencyHeading.totalMarginamt}
							/>
						</span>
					</div>
				</li>
			</ul>

			{props.tableData.length ? (
				<ul className="mrgn_scrl_cont data_rows">
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td trdSym robotoM">
								<span dangerouslySetInnerHTML={{ __html: row.trdSym }}></span>
							</div>
							<div className="td LotSize">{row.LotSize}</div>
							<div className="td SPANMarginAmt right">
								{toINR(row.SPANMarginAmt)}
								<br />
								<span className="row_2">{toINR(row.SPANMarginper)}%</span>
							</div>
							<div className="td ExpMarginamt right">
								{toINR(row.ExpMarginamt)}
								<br />
								<span className="row_2">{toINR(row.ExpMarginper)}%</span>
							</div>
							<div className="td TotalMarginamt right">
								{toINR(row.TotalMarginamt)}
								<br />
								<span className="row_2">{toINR(row.TotalMarginper)}%</span>
							</div>
						</li>
					))}
				</ul>
			) : (
				<NoDataContainer txtHeading="No results found" />
			)}
		</div>
	);
};

export default MarginCurrencyTableDsk;
